// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import OrderComplaintState from "@store/Framework/Store/Greif/Pages/OrderComplaint/OrderComplaintState";
import { OrderComplaintModel } from "@store/Framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: OrderComplaintState = {
    orderLine: null,
};

const actions = {
    "Greif/Pages/OrderComplaint/BeginSendOrderComplaintRequest": (draft: Draft<OrderComplaintState>) => {
        draft.resultMessage = undefined;
    },
    "Greif/Pages/OrderComplaint/CompleteSendOrderComplaintRequest": (
        draft: Draft<OrderComplaintState>,
        action: { result?: OrderComplaintModel },
    ) => {
        draft.resultMessage = action.result?.message;
    },
    "Greif/Pages/OrderComplaint/SetOrderLines": (
        draft: Draft<OrderComplaintState>,
        action: { orderLine: OrderLineModel | null },
    ) => {
        draft.orderLine = action.orderLine;
    },
    "Greif/Pages/OrderComplaint/SetQtyNonConformancies": (
        draft: Draft<OrderComplaintState>,
        action: { qtyNonConformancies: number },
    ) => {
        draft.qtyNonConformancies = action.qtyNonConformancies;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifOrderComplaintPagesActions = Parameters<typeof reducer>[1];
export default reducer;
